var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoundsign = function SvgPoundsign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98a2b3",
    d: "M17.334 20.05h.05V17.9h-7.295c.456-.62.617-1.436.573-2.364l-.06-1.667h3.548v-2.15H10.52l-.106-2.834c0-.975.31-1.677.777-2.136.466-.46 1.094-.68 1.738-.68.618 0 1.215.188 1.639.557.42.368.673.918.598 1.654l-.005.047.046.008 2.226.354.048.008.009-.049c.438-2.48-1.596-4.698-4.646-4.698-1.289 0-2.522.416-3.42 1.243-.897.827-1.455 2.063-1.396 3.695l.09 2.83H6.45v2.15h1.742l.06 1.733c.015.44-.025 1.01-.172 1.473-.148.467-.395.804-.78.826h-.796v2.15h10.83Z"
  })));
};
export default SvgPoundsign;